export const routes = {
  index: "/",
  registrationCompleted: "/registration-completed",
  deliveries: {
    home: "/deliveries",
    orders: {
      index: "/deliveries/orders",
      orderIdentifier: "/deliveries/orders/:orderIdentifier"
    },
    productInformation: {
      index: "/deliveries/product-information",
      productSerialNumber: "/deliveries/product-information/:productSerialNumber",
      licenses: "/deliveries/product-information/licenses/:serialNumber"
    }
  },
  manage: {
    users: "/manage/users",
    usersEdit: "/manage/users/:userId",
    companies: "/manage/companies",
    company: "/manage/companies/:companyId",
    statistics: "/manage/statistics",
    accessRequests: "/manage/access-requests",
    accessRequestsEmailFilter: "/manage/access-requests/:emailFilter",
    orderNotifications: "/manage/notifications",
    translations: "/manage/translations",
    priceLists: "/manage/price-lists",
    termsConditions: "/manage/terms-and-conditions",
    quotes: "/manage/quotes",
    quote: "/manage/quote",
    emailTemplates: "/manage/email-templates",
    quoteById: "/manage/quote/:quoteId" 
  },
  user: {
    information: "/user/information",
    requestAccess: "/user/request-access",
    notifications: "/user/notifications",
    notificationDetails: "/user/notifications/:notificationId"
  },
  training: {
    managementView: "/training/management",
    trainingView: "/training",
    knowledgeWarehouseView: "/knowledge-warehouse"
  },
  products: {
    home: "/products",
    productSelectionMatrix: "/products/product-selection-matrix"
  },
  quickPriceCheck: "/quick-price-check",
  shoppingCart: "/shopping-cart",
  shoppingCartByGuid: "/shopping-cart/:shoppingCartGuid",
  shoppingCarts: "/shopping-carts"
};
